import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { getSolution, type SolutionId } from '../../data/solutionCatalog';
import { fadeUp } from '../../utils/motion';
type RelatedSolutionsProps = {
  title: string;
  body: string;
  ids: SolutionId[];
};

/** A compact cross-link row to related solutions. */
export function RelatedSolutions({
  title,
  body,
  ids
}: RelatedSolutionsProps) {
  return <section className="bg-surface-bg border-y border-line py-14 lg:py-16" data-id="element-2533" data-mp="vo3stmrmzwir">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16" data-id="element-2534" data-mp="qpan4gild9t5">
        <div className="lg:col-span-5" data-id="element-2535" data-mp="mm4b0s8ssoer">
          <h2 className="font-heading font-bold text-2xl text-ink-dark tracking-tight" data-id="element-2536" data-mp="hp4fhb9kr41w">{title}</h2>
          <p className="mt-3 text-ink-muted leading-relaxed" data-id="element-2537" data-mp="37dwpmh0ghhpd">{body}</p>
        </div>
        <ul className="lg:col-span-7 border-t border-line" data-id="element-2538" data-mp="37btrf9p5gi9k">
          {ids.map(id => {
          const solution = getSolution(id);
          return <li key={id} className="border-b border-line" data-id="element-2539" data-mp="vylqfmlxdy8c">
                <a href={solution.href} className="group flex items-center justify-between gap-4 py-4 text-ink-dark hover:text-navy transition-colors duration-150" data-id="element-2540" data-mp="10wx4k9j96uwd">
                  <span className="font-heading font-semibold" data-id="element-2541" data-mp="runutlvt75k1">{solution.pageTitle}</span>
                  <ArrowRight size={16} aria-hidden="true" className="shrink-0 text-ink-muted group-hover:text-navy transition-colors duration-150" data-id="element-2542" data-mp="d6klq3mgzdr0" />
                </a>
              </li>;
        })}
        </ul>
      </motion.div>
    </section>;
}